import { getContext } from '@fiverr-private/fiverr_context';
import { MOBILE_MAX_SELLER_RESPONSE_LENGTH, DESKTOP_MAX_SELLER_RESPONSE_LENGTH, TEXT } from '../../../constants';

const DEFAULT_POSITION = 1;

export const getCommentLength = () =>
    getContext().isMobile ? MOBILE_MAX_SELLER_RESPONSE_LENGTH : Number.MAX_SAFE_INTEGER;
export const getNewCommentLength = () =>
    getContext().isMobile ? MOBILE_MAX_SELLER_RESPONSE_LENGTH : DESKTOP_MAX_SELLER_RESPONSE_LENGTH;

export const impressionConfig = (componentName) => ({
    DOMSelector: `.${componentName}`,
    getImpressionData: (data, { encryptedOrderId }) => ({
        type: 'review_is_shown',
        page: {
            element: {
                position: DEFAULT_POSITION,
                name: 'seller_response',
                type: TEXT,
            },
            component: {
                name: 'review',
            },
        },
        order: {
            encrypted_id: encryptedOrderId,
        },
    }),
});
